
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "FormLoader",
  props: {
    logo: String,
  },
  setup() {
    const store = useStore();

    const loaderType = computed(() => {
      return store.getters.layoutConfig("loader.type");
    });
    const formLoaderEnabled = computed(() => {
      return store.getters.getFormLoading;
    });

    return {
      loaderType,
      formLoaderEnabled,
    };
  },
});
